import React, { useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { Button } from '@app/components';
import { Modal } from 'react-bootstrap';
import { updateLeadDetails } from '@app/services/lead';
import { getCentresByFranchiseId } from '@app/services/centre';

const UpdateLeadDetailsModal = (props) => {

    const [isLoading, setLoading] = useState(false);
    const [isConfirmed, setConfirmed] = useState(false);
    const [centres, setCentres] = useState([]);
    const [hasCentres, setHasCentres] = useState(true);

    useEffect(() => {
        if(props?.show){
            setConfirmed(hasTargetStatus())
            getAllActiveCentresByFranchise(props?.payload?.franchise_id);
        }
    }, [props?.show]);

    const getAllActiveCentresByFranchise = async (id) => {
        try{
            const resp = await getCentresByFranchiseId(id);
            if (resp.success === true) {
                setHasCentres(resp.collections?.length > 0);
                const centres = resp.collections?.length > 0
                        ? [{ id: "", name: "Please Select Centre" }, ...resp.collections]
                        : [{ id: "", name: "No Centres" }];
                setCentres(centres);
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        }catch (error: any){
            toast.error(error?.message || 'Internal server error');
        }
    }

    const hasTargetStatus = () => {
        if (!Array.isArray(props?.payload?.subjects)) return false;

        return props?.payload?.subjects.some(subject =>
            Array.isArray(subject.journey) &&
            subject.journey.some(j => [7, 8, 12].includes(j.lead_inquiry_status_id))
        );
    }

    const updateLead = async (payload) => {
        try {
            setLoading(true);
            const resp = await updateLeadDetails(props?.payload?.lead_inquiry_id, payload);
            if(resp.success === true){
                toast.success(resp?.message);
                setLoading(false);
                props.handleClose();
                props.reload();
            }else{
                toast.error(resp?.errors[0]?.msg);
                setLoading(false);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal server error');
        }
    };

    const { handleChange, values, handleSubmit, touched, errors } = useFormik({
        initialValues: {
            franchise_name: props?.payload?.franchise_name || '',
            centre_id: props?.payload?.centre_id || '',
            parent_email: props?.payload?.parent_email || '',
            parent_phone: props?.payload?.parent_phone || '',
            parent_first_name: props?.payload?.parent_first_name || '',
            parent_last_name: props?.payload?.parent_last_name || '',
            student_id: props?.payload?.lead_inquiry_student_id || '',
            student_first_name: props?.payload?.student_first_name || '',
            student_last_name: props?.payload?.student_last_name || '',
        },
        validationSchema: Yup.object({
            parent_first_name: Yup.string().trim().required('Please enter parent first name'),
            parent_last_name: Yup.string().trim().required('Please enter parent last name'),
            parent_email: Yup.string().trim().required("Please enter email address").email("Enter valid email"),
            parent_phone: Yup.string().trim().required('Please enter mobile number')
                .matches(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/, "Please enter valid number" ),
            student_id: Yup.string().required('Please enter student id'),
            student_first_name: Yup.string().trim().required('Please enter student first name'),
            student_last_name: Yup.string().trim().required('Please enter student last name'),
        }),
        onSubmit: (values) => {
            if (isConfirmed && props?.payload?.parent_email) {
                delete values.parent_email;
            }
            if (isConfirmed && props?.payload?.parent_phone) {
                delete values.parent_phone;
            }
            updateLead(values);
        },
        enableReinitialize: true,
    });

    return (
    <div>
        <Modal show={props.show} onHide={props.handleClose}  size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Update Lead Details</Modal.Title>
            </Modal.Header>
            <form onSubmit={handleSubmit}>
                <Modal.Body>
                    <div className='row'>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label htmlFor="parent_email">Email <span className="required">*</span></label>
                                <input type="email" className="form-control" id="parent_email" placeholder="Enter email" 
                                    name="parent_email" 
                                    onChange={handleChange}
                                    value={values.parent_email}
                                    disabled={props?.payload?.parent_email != null && isConfirmed}
                                />
                                {(touched.parent_email && errors.parent_email) && (
                                    <div className="text-danger">
                                        {errors.parent_email}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label htmlFor="parent_phone">Contact (WhatsApp Number) <span className="required">*</span></label>
                                <input type="text" className="form-control" id="parent_phone" placeholder="Enter mobile number" 
                                    name="parent_phone" 
                                    onChange={handleChange} 
                                    value={values.parent_phone}
                                    disabled={props?.payload?.parent_phone != null && isConfirmed}
                                />
                                {(touched.parent_phone && errors.parent_phone) && (
                                    <div className="text-danger">
                                        {errors.parent_phone}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label htmlFor="franchise_name">Franchise <span className="required">*</span></label>
                                <input type="text" className="form-control" id="franchise_name"
                                    name="franchise_name"
                                    onChange={handleChange}
                                    value={values.franchise_name}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label htmlFor="exampleInputGrade" className="">Centre</label>
                                <select
                                    className="form-control"
                                    name="centre_id"
                                    onChange={ handleChange}
                                    value={values.centre_id}
                                    disabled={!hasCentres}
                                >
                                    {centres.map((obj) => (
                                        <option key={obj.id} value={obj.id}>
                                            {obj.name}
                                        </option>
                                    ))}
                                </select>
                                {(touched.centre_id && errors.centre_id) && (
                                    <div className="text-danger">
                                        {errors.centre_id}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label htmlFor="parent_first_name">Parent First Name <span className="required">*</span></label>
                                <input type="text" className="form-control" id="parent_first_name" placeholder="Enter parent first name" 
                                    name="parent_first_name" 
                                    onChange={handleChange} 
                                    value={values.parent_first_name}
                                />
                                {(touched.parent_first_name && errors.parent_first_name) && (
                                    <div className="text-danger">
                                        {errors.parent_first_name}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label htmlFor="parent_last_name">Parent Last Name <span className="required">*</span></label>
                                <input type="text" className="form-control" id="parent_last_name" placeholder="Enter parent last name" 
                                    name="parent_last_name" 
                                    onChange={handleChange} 
                                    value={values.parent_last_name}
                                />
                                {(touched.parent_last_name && errors.parent_last_name) && (
                                    <div className="text-danger">
                                        {errors.parent_last_name}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label htmlFor="student_first_name">Student First Name <span className="required">*</span></label>
                                <input type="text" className="form-control" id="student_first_name" placeholder="Enter student first name" 
                                    name="student_first_name" 
                                    onChange={handleChange} 
                                    value={values.student_first_name}
                                />
                                {(touched.student_first_name && errors.student_first_name) && (
                                    <div className="text-danger">
                                        {errors.student_first_name}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label htmlFor="student_last_name">Student Last Name <span className="required">*</span></label>
                                <input type="text" className="form-control" id="student_last_name" placeholder="Enter student last name" 
                                    name="student_last_name" 
                                    onChange={handleChange} 
                                    value={values.student_last_name}
                                />
                                {(touched.student_last_name && errors.student_last_name) && (
                                    <div className="text-danger">
                                        {errors.student_last_name}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="submit" isLoading={isLoading} className="btn btn-primary mr-2">Update </Button>
                    <Button className='btn btn-default' onClick={props.handleClose}>Close</Button>
                </Modal.Footer>
            </form>
        </Modal>
    </div>
  )
}

export default UpdateLeadDetailsModal;